import {Component, Input} from '@angular/core';
import {ActivationRequestService} from './activation-request.service';
import {EventsService} from '@services/events.service';

@Component({
    selector: 'app-activation-request',
    providers: [
        ActivationRequestService
    ],
    template: `
        <h3>Активация профиля</h3>
        <app-info-block>
            <p>Ваш профиль не активирован.</p>
            <a href="javascript:;" (click)="sendActivationCode()">
                Отправить ссылку активации <ng-container *ngIf="email">на {{email}}</ng-container>
            </a>
        </app-info-block>
    `
})

export class ActivationRequestComponent {
    public pending = false;

    @Input() email: string;

    constructor(
        private service: ActivationRequestService,
        private events: EventsService,
    ) {}

    sendActivationCode() {
        if (this.pending) {
            return;
        }

        this.pending = true;

        this.service.get().toPromise().then(() => {
            this.pending = false;
            this.events.notyShow$.next({
                type: 'success',
                content: 'Код активации отправлен ' + (this.email ? `на ${this.email}` : ''),
            });
        }, () => {
            this.pending = false;
            this.events.notyShow$.next({
                type: 'error',
                content: 'Не удалось отправить код активации, повторите попытку позднее',
            });
        });
    }
}
